export const handleValidateMatching = ({
  that,
  field,
  value,
  questionnaireIndex,
}) => {
  const { previousTestResults = [] } = that.state;
  const fv = value?.value || value;
  const normalizedValue =
    typeof fv === "string" ? fv.toUpperCase().trim() : fv;
  const nextError = { ...(that.state.error || {}) };
  const nextMismatchFields = [...(that.state.misMatchFields || [])].filter(
    (item) => item !== field,
  );

  const activePreviousResults = (previousTestResults || []).filter((result) => {
    if (result.status === "cancelled") return false;

    const hasComparableBloodGroup =
      typeof result?.bloodGroup === "string" && result.bloodGroup.trim() !== "";
    const hasComparableQuestionnaire =
      Array.isArray(result?.questionnaire) && result.questionnaire.length > 0;

    return hasComparableBloodGroup || hasComparableQuestionnaire;
  });

  if (activePreviousResults.length === 0) {
    delete nextError[field];

    that.setState({
      error: nextError,
      misMatchFields: nextMismatchFields,
    });

    return;
  }

  if (field === "bloodGroup") {
    const normalizeBloodGroup = (bg) =>
      typeof bg === "string" ? bg.replace(/\s*Du\+.*$/i, "").trim() : bg;
    const hasMismatch = activePreviousResults.some(
      (result) =>
        normalizeBloodGroup(result.bloodGroup) !== normalizeBloodGroup(fv),
    );

    if (hasMismatch) {
      nextError[field] = "Mismatch";
      if (!nextMismatchFields.includes(field)) {
        nextMismatchFields.push(field);
      }
    } else {
      delete nextError[field];
    }
  } else if (questionnaireIndex !== undefined) {
    const hasMismatch = activePreviousResults.some((result) =>
      (result.questionnaire || []).some((question) => {
        const previousAnswer = question.answer?.value || question.answer;
        console.log(question);

        if (
          result.sampleCollectionMethod?.toUpperCase() === "QUALYS" &&
          (question.questionText?.toUpperCase() === "ANTIBODY SCREENING" ||
            question.questionText?.toUpperCase() === "LISS" ||
            question.questionText?.toUpperCase() ===
              "INDIRECT ANTIGLOBULIN TEST - IAT (DU+/D-)")
        ) {
          return false;
        }
        const normalizedPreviousAnswer =
          typeof previousAnswer === "string"
            ? previousAnswer.toUpperCase().trim()
            : previousAnswer;

        return (
          question.questionText?.toUpperCase() === field?.toUpperCase() &&
          normalizedPreviousAnswer !== normalizedValue
        );
      }),
    );

    if (hasMismatch && !nextMismatchFields.includes(field)) {
      nextMismatchFields.push(field);
    }
  }

  that.setState({
    error: nextError,
    misMatchFields: nextMismatchFields,
  });
};
